/*
创建者 魏强(2018.2.8)
同城商家
*/
<template>
  <div
    class="row-fluid clearfix merchant-page"
    id="merchant"
  >
    <div class="merch-sidebar">
      <!--search begin-->
      <div class="nc-s-c-s1 ncs-search-bar">
        <div class="title">
          <h4>本地商户搜索</h4>
        </div>
        <div class="content merch-serach">
          <p>
            <Select
              v-model="provinceId"
              size="small"
              clearable
              style="width:180px"
              placeholder="请选择省份"
              @on-change="fetchCityList"
              :transfer="true"
            >
              <Option
                v-for="item in provinceList"
                :value="item.regionId"
                :key="item.regionId"
              >
                {{ item.localName }}
              </Option>
            </Select>
          </p>
          <p>
            <Select
              v-model="cityId"
              size="small"
              clearable
              style="width:180px"
              placeholder="请选择市"
              :transfer="true"
              @on-change="fetchRegionList"
            >
              <Option
                v-for="item in cityList"
                :value="item.regionId"
                :key="item.regionId"
              >
                {{ item.localName }}
              </Option>
            </Select>
          </p>
          <p>
            <Select
              v-model="regionId"
              size="small"
              clearable
              style="width:180px"
              placeholder="请选择区"
              :transfer="true"
            >
              <Option
                v-for="item in regionList"
                :value="item.regionId"
                :key="item.regionId"
              >
                {{ item.localName }}
              </Option>
            </Select>
          </p>
          <p>
            <Select
              v-model="storeType"
              size="small"
              clearable
              style="width:180px"
              placeholder="请选择店铺类型"
            >
              <Option
                v-for="item in storeTypeList"
                :value="item.value"
                :key="item.value"
              >{{ item.label }}</Option>
            </Select>
          </p>
          <p>
            <Input
              v-model="storeName"
              size="small"
              class="asdf22"
              placeholder="输入商家名"
              style="width:180px;"
            ></Input>
          </p>
          <p>
            <Button
              type="ghost"
              size="small"
              icon="ios-search"
              @click="searchStore"
            >搜索商家</Button>
          </p>
        </div>
      </div>
    </div>

    <div class="merch-content">
      <store-list :data="storesList"></store-list>

      <div class="tc mt20 mb20">
        <Alert v-if="storesList.length==0&&!this.loading">
          没有更多数据...
        </Alert>
        <div
          v-show="totalCount>0"
          class="page-wrapper"
        >
          <Page
            :total="totalCount"
            :page-size="pageSize"
            show-elevator
            show-total
            @on-change="changePage"
          ></Page>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAddressInfo } from "api/user";
import { getLocalStoreList } from "api/home";
import list from "./list";
export default {
  components: {
    storeList: list,
  },
  data() {
    return {
      storeName: "",
      provinceList: [],
      cityList: [],
      regionList: [],
      storeTypeList: [
        { value: 0, label: "全部" },
        { value: 1, label: "个人网店" },
        { value: 2, label: "企业品牌" },
        { value: 4, label: "金牌网店" },
        { value: 5, label: "银牌网店" },
      ], // 店铺类型
      storeType: "",
      pageNo: 1,
      pageSize: 60,
      storeName: "",
      addressAll: {}, //保存全部数据
      provinceId: "",
      cityId: "",
      regionId: "",
      totalCount: 0,
      storesList: [],
      loading: false,
    };
  },
  created() {
    if (localStorage.getItem("townList")) {
      this.addressAll = JSON.parse(localStorage.getItem("townList")).data;
      this.provinceList = JSON.parse(
        localStorage.getItem("townList")
      ).data.provinceList;
    } else {
      this.fetchProvinceList();
    }
    this.fetchData();
  },
  methods: {
    fetchProvinceList() {
      getAddressInfo().then((json) => {
        this.addressAll = json.data;
        this.provinceList = [{ localName: "全部", regionId: "" }].concat(
          json.data.provinceList
        );
      });
    },
    fetchCityList(item) {
      if (!item) return;
      this.cityList = this.addressAll.cityList.filter(v => v.parentRegionId == item)
      this.cityId = ''
      this.regionId = ''
    },
    fetchRegionList(item) {
      if (!item) return;
      this.regionList = this.addressAll.areaList.filter(v => v.parentRegionId == item)
      this.regionId = ''
    },
    changePage(index) {
      this.pageNo = index;
      this.fetchData();
    },
    searchStore() {
      this.pageNo = 1;
      this.fetchData();
    },
    fetchData() {
      if (!this.loading) {
        let postData = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          storeName: this.storeName,
          provinceId: this.provinceId,
          cityId: this.cityId,
          regionId: this.regionId,
          storeType: this.storeType,
        };
        this.loading = true;
        getLocalStoreList(postData).then((json) => {
          this.loading = false;
          if (json.resCode == 1) {
            let data = json.data;
            this.storesList = data.list;
            this.totalCount = data.total;
          }
        });
      }
    },
  },
};
</script>
<style >
.merchant-page input.ivu-input.ivu-input-small {
  height: 24px !important;
  width: 163px;
}
</style>
<style lang="less" >
@import "../../assets/css/merchant.less";
</style>



// WEBPACK FOOTER //
// index.vue?1af2e6be